import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './styles/globals.css';
import 'leaflet/dist/leaflet.css';
import './i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { Toaster } from '@/components/ui/toast';
import { SentryErrorBoundary } from './observability/error-boundary';
import { initSentry } from './observability/sentry';
import { registerServiceWorker } from './pwa/register-service-worker';
import { AuthProvider } from './auth/AuthProvider';
import { TenantPortalProvider } from './contexts/TenantPortalContext';
import { TenantBrandingProvider } from './branding/TenantBrandingProvider';
import { CurrencyProvider } from './features/finance/state/currencyStore';
import { PeriodProvider } from './features/finance/state/periodStore';
import { queryClient } from './lib/query-client';
import { BootstrapProvider } from './lib/api/BootstrapProvider';

void initSentry();
void registerServiceWorker();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <SentryErrorBoundary>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          {/* W127-F2: bootstrap query mounted once per session; seeds
              memberships + subtree + notifications-summary caches so
              every consumer hook reads hot data without per-mount
              round-trip. Root-cause fix for the throttler storm. */}
          <BootstrapProvider>
            <TenantPortalProvider>
              <TenantBrandingProvider>
                <CurrencyProvider>
                  <PeriodProvider>
                    <RouterProvider router={router} />
                    <Toaster />
                  </PeriodProvider>
                </CurrencyProvider>
              </TenantBrandingProvider>
            </TenantPortalProvider>
          </BootstrapProvider>
        </QueryClientProvider>
      </AuthProvider>
    </SentryErrorBoundary>
  </StrictMode>,
);
